<oe-history-data-error [response]="errorResponse"></oe-history-data-error>
@if (chartTitle) {
  <table class="full_width">
    <tr>
      <td style="width: 100%" class="ion-padding">{{chartTitle}}</td>
    </tr>
  </table>
}
<div [style.height.px]="getChartHeight()" id="chart-area" class="semi-transparent-background ion-padding-top">
  <ngx-spinner [name]="spinnerId"></ngx-spinner>
  @if (!loading) {
    <canvas style="padding-bottom: 2vh;" baseChart [datasets]="datasets" [labels]="labels" [options]="options"
    [type]="chartType"></canvas>
  }
</div>
